// Tema de bioma por fase — fonte ÚNICA de cor para a moldura viva (StageAmbience),
// a moldura de arena (GameShell) e o game feel (juice). Cada Ciclo é um "mundo"
// com cor-assinatura; dentro do ciclo, a intensidade sobe da 1ª à última fase,
// dando 50 telas distintas mas coerentes (mundo + profundidade da jornada).
//
// Regra AAA: verde e vermelho ficam RESERVADOS para feedback (acerto/erro).
// Os biomas usam âmbar → ciano → índigo → violeta → púrpura (amanhecer → ápice).

import { CICLOS } from './quizUtils';

export interface BiomeTheme {
  /** "r, g, b" pronto para rgba(var(--amb), a). */
  rgb: string;
  /** Multiplicador de intensidade 0.82→1.22 conforme o avanço no ciclo. */
  intensity: number;
  /** Índice do ciclo (0..4). */
  cicloIndex: number;
  /** Nome do ciclo (ex.: "III. Resistência"). */
  cicloNome: string;
}

// Cor-assinatura por ciclo (mesma ordem de quizUtils.CICLOS). Sem verde/vermelho.
const CORES_CICLO: string[] = [
  '245, 158, 11', // I  — Despertar   (âmbar / amanhecer)
  '14, 165, 233', // II — Sabedoria   (ciano / clareza)
  '99, 102, 241', // III— Resistência (índigo / profundidade)
  '139, 92, 246', // IV — Legado      (violeta / nobreza)
  '168, 85, 247', // V  — O Ápice     (púrpura / tribunal)
];

const CICLO_FALLBACK = CORES_CICLO[0];

export function getBiomeTheme(fase: number): BiomeTheme {
  const idx = CICLOS.findIndex(({ fases }) => fase >= fases[0] && fase <= fases[1]);
  const cicloIndex = idx >= 0 ? idx : 0;
  const ciclo = CICLOS[cicloIndex];

  // Progresso 0..1 dentro da faixa do ciclo (fase inicial = 0, final = 1).
  const [ini, fim] = ciclo?.fases ?? [1, 10];
  const span = Math.max(1, fim - ini);
  const progresso = Math.min(1, Math.max(0, (fase - ini) / span));

  return {
    rgb: CORES_CICLO[cicloIndex] ?? CICLO_FALLBACK,
    intensity: 0.82 + 0.4 * progresso,
    cicloIndex,
    cicloNome: ciclo?.nome ?? 'I. Despertar',
  };
}
